import {
  STAGE_2,
  TRANSPORTATION_FIELD_STAGE2,
} from 'constants/FarmboxConstants/stage2.constants';
import { FieldType } from 'enums/FieldTypeEnums';
import { TemperatureControl } from 'views/CreateProductFlow/Transportation/TransportationConstants';
import { CategoryOptions } from 'shared/components/CreateProductModal/ProductModalForm';
import { ReactComponent as Add } from 'assets/icons/add.svg';
import React, { useContext, useState } from 'react';
import { TransportationProps } from 'enums/TransportationEnums';
import styles from './farmTransportationFlow.module.scss';
import HelpdeskService from 'services/HelpdeskService/Helpdesk.service';
import { HelpDeskContext } from 'context/HelpDeskContext';

interface TransportationDataProps {
  rowIndex: number;
  childIndex?: number;
  supplierOptions?: CategoryOptions[];
  openSupplierModal?: () => void;
  formType: TRANSPORTATION_FIELD_STAGE2;
  isDisabled?: boolean;
}
export const GetFertilizerFormFields = (props: TransportationDataProps) => {
  const { setHelpDeskData } = useContext(HelpDeskContext);
  const { fetchData } = HelpdeskService(setHelpDeskData);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const {
    rowIndex,
    supplierOptions,
    childIndex,
    openSupplierModal,
    formType,
    isDisabled,
  } = props;
  const { INPUT, SELECT, CHECKBOX } = FieldType;
  const { FERTILIZER_LABELS, TRANSPORTATION_FIELD_NAMES, PACKAGING_LABELS } =
    STAGE_2;
  const {
    SUPPLIER,
    GUTTER_VALUE,
    TEMPERATURE_CONTROL,
    INGREDIENT_NAME,
    INGREDIENT_ORIGIN,
    CHECK_TRANSPORTATION,
  } = FERTILIZER_LABELS;
  const {
    NAME_FIELD,
    IS_AIR_TRANSPORTED_FIELD,
    ORIGIN_FIELD,
    SUPPLIER_FIELD,
    TEMPERATURE_CONTROL_FIELD,
    FERTILIZER,
  } = TRANSPORTATION_FIELD_NAMES;

  const { MATERIAL_NAME, MATERIAL_ORIGIN } = PACKAGING_LABELS;

  const baseFieldName = `${formType}.${rowIndex}${
    childIndex !== undefined ? `.children.${childIndex}` : ''
  }`;
  const handleClick = () => {
    openSupplierModal?.();
    setDropdownOpen(false);
  };
  const dropdownRender = (menu: CategoryOptions[]) => {
    return (
      <>
        <div className={styles.dropdownCreateButton} onClick={handleClick}>
          <Add /> {TransportationProps.CREATE_SUPPLIER}
        </div>
        {menu}
      </>
    );
  };
  const handleDropdownChange = (visible: boolean) => {
    setDropdownOpen(visible);
  };
  return {
    data: [
      {
        type: INPUT,
        fieldProps: {
          name: `${baseFieldName}.${NAME_FIELD}`,
          label: formType === FERTILIZER ? INGREDIENT_NAME : MATERIAL_NAME,
          disabled: true,
        },
        span: 5,
        className: childIndex !== undefined ? 'visibility-hidden' : '',
      },
      {
        type: INPUT,
        fieldProps: {
          name: `${baseFieldName}.${ORIGIN_FIELD}`,
          label: formType === FERTILIZER ? INGREDIENT_ORIGIN : MATERIAL_ORIGIN,
          disabled: true,
        },
        span: 4,
      },
      {
        type: SELECT,
        fieldProps: {
          name: `${baseFieldName}.${SUPPLIER_FIELD}`,
          label: SUPPLIER,
          placeholderstring: SUPPLIER,
          options: supplierOptions,
          dropdownRender,
          open: dropdownOpen,
          onDropdownVisibleChange: handleDropdownChange,
          onFocus: () =>
            fetchData({
              'input-field': 'farmbox_ag_commodity_supplier',
            }),
          disabled: isDisabled,
        },
        span: 4,
      },
      ...(formType === FERTILIZER
        ? [
            {
              type: SELECT,
              fieldProps: {
                name: `${baseFieldName}.${TEMPERATURE_CONTROL_FIELD}`,
                label: TEMPERATURE_CONTROL,
                placeholderstring: TEMPERATURE_CONTROL,
                options: TemperatureControl,
                onFocus: () =>
                  fetchData({
                    'input-field': 'farmbox_ag_commodity_temperature_control',
                  }),
                disabled: isDisabled,
              },
              span: 5,
            },
          ]
        : []),
      {
        type: CHECKBOX,
        fieldProps: {
          name: `${baseFieldName}.${IS_AIR_TRANSPORTED_FIELD}`,
          label: CHECK_TRANSPORTATION,
          disabled: isDisabled,
        },
        span: 6,
      },
    ],
    rowGutter: GUTTER_VALUE,
  };
};
